import {Link,useLocation} from 'react-router';
import {useStaffSession} from './StaffSession';
import {withBuildingScope} from './building-scope';
import {buildingDestinations,buildingNavigationSection} from './workspace-navigation';
import {safeWorkflowReturn,workflowRecordLabel} from './workflow-context';

/** Existing record pages share one clear route back to their permitted building. */
export function RecordBreadcrumbs({workspaceLabel}:{workspaceLabel?:string}){
 const session=useStaffSession(),location=useLocation();
 const scope=session?.effectiveScope,label=workflowRecordLabel(location.pathname,location.search);
 if(!session)return null;
 if(scope?.kind!=='building'||!label)return <nav className="record-breadcrumbs" aria-label="Record location"><ol><li>{scope?.kind==='building'?scope.name:'All buildings'}</li><li aria-current="page">{workspaceLabel??'Workspace'}</li></ol></nav>;
 const origin=safeWorkflowReturn(new URLSearchParams(location.search).get('returnTo'));
 if(origin&&/^\/buildings\/[^/]+\/(?:onboarding|setup)(?:\?|$)/.test(origin))return null;
 const area=buildingDestinations(session,scope.id).find(item=>item.id===buildingNavigationSection(location.pathname,location.search));
 return <nav className="record-breadcrumbs" aria-label="Record location"><ol>
  <li><Link to={withBuildingScope(`/buildings/${scope.id}`,scope.id)}>{scope.name}</Link></li>
  {area&&area.id!=='overview'&&<li><Link to={area.href}>{area.label}</Link></li>}
  <li aria-current="page">{label}</li>
 </ol></nav>;
}
